import React, { useState } from "react";
import { parseLocalDate } from "utils/dateUtil";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import { IconButton, Chip } from "@mui/material";
import { Edit, Delete, Done as CheckCircle } from "components/icons";

const getStatusColor = (status) => {
  const colors = {
    DRAFT: "default",
    ACTIVE: "success",
    UNDER_REVIEW: "warning",
    DEPRECATED: "error",
  };
  return colors[status] || "default";
};

export const ProcessDataGrid = ({ processes, isLoading, onEdit, onDelete, showActions = true }) => {
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    ...(showActions ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <IconButton key="edit" onClick={() => onEdit(params.row)} color="primary" size="small">
          <Edit />
        </IconButton>,
        <IconButton key="delete" onClick={() => onDelete(params.row)} color="error" size="small">
          <Delete />
        </IconButton>,
      ],
    }] : []),
    { field: "id", headerName: "ID", width: 80 },
    { field: "processCode", headerName: "Code", width: 120 },
    { field: "processName", headerName: "Process Name", width: 200, flex: 1 },
    { field: "category", headerName: "Category", width: 140 },
    { field: "owner", headerName: "Owner", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <Chip
          icon={params.value === "ACTIVE" ? <CheckCircle /> : null}
          label={params.value?.replace("_", " ")}
          color={getStatusColor(params.value)}
          size="small"
        />
      ),
    },
    { field: "version", headerName: "Version", width: 90 },
    {
      field: "lastReviewDate",
      headerName: "Last Review",
      width: 120,
      valueFormatter: (value) => value ? parseLocalDate(value).toLocaleDateString() : "N/A",
    },
  ];

  return (
    <MDBox pt={3} py={3} px={2} height={400}>
      <DataGrid
        rows={processes || []}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50]}
        loading={isLoading}
        disableSelectionOnClick
        getRowId={(row) => row.id || row.processId}
      />
    </MDBox>
  );
};

ProcessDataGrid.propTypes = {
  processes: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  showActions: PropTypes.bool,
};

export default ProcessDataGrid;

